export const FETCH_ADDRESS = 'FETCH_ADDRESS';
export const FETCH_ADDRESS_FULFILLED = 'FETCH_ADDRESS_FULFILLED';
export const FETCH_ADDRESS_REJECTED = 'FETCH_ADDRESS_REJECTED';
export const CLEAR_ACCOUNT_ADDRESS = 'CLEAR_ACCOUNT_ADDRESS';
export const REMOVE_ADDRESS = 'REMOVE_ADDRESS';
export const ADD_ADDRESS = 'ADD_ADDRESS';
export const EDIT_ADDRESS = 'EDIT_ADDRESS';
